import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11 * (props.wx ?? 1)}
    height={32 * (props.hx ?? 1)}
    viewBox="0 0 11 32"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.343 3.513c.238-.427.917-1.006 1.663-1.4.746-.396 1.298-1.045 2.129-1.107.883-.067 1.931.484 2.447.664.828.29 1.5.546 2.21 1.245 1.287 1.265-.207 7.039-.619 8.173-.266.732-.45 1.05-.68 2.108-.899 4.147-.214 7.8-.667 13.022-.253 2.907.1 4.177-.577 4.332-.53.122-1.743-1.492-2.17-4.289-.84-5.505-1.504-8.28-2.058-12.663-.141-1.119-.39-1.92-.708-2.507a8 8 0 0 1-.479-1.055c-.652-1.76-1.223-5.211-.49-6.523z"
    />
  </svg>
);
export default SvgNormal;
